export default function MinusIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="minus-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M11.5 26q-.85 0-1.425-.575Q9.5 24.85 9.5 24q0-.85.575-1.425Q10.65 22 11.5 22h25q.85 0 1.425.575.575.575.575 1.425 0 .85-.575 1.425Q37.35 26 36.5 26Z"
      />
    </svg>
  );
}
